import store from '@/store'
export default [
  {
    path: '/companies',
    name: 'company',
    meta: { requiresAuth: true },
    component: () => import('@/pages/company/index-v2.vue')
  },
  {
    path: '/companies/create',
    name: 'company-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/company/create.vue')
  },
  {
    path: '/companies/:id',
    name: 'company-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/company/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('company/find', to.params.id)
      next()
    }
  }
]
